//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



import FETCHING from  '../../library/fetching'
import UMUM from  '../../library/umum'
import WILAYAH from  '../../library/getWilayah'

import Joi from "joi";
const schema = Joi.object().keys({
  username: Joi.string().regex(/^[a-zA-Z0-9_]*$/).min(3).max(13).required(),
  password: Joi.string().min(6).required(),
});


export default {
  data() {
    return {

      token : '',

      form : {
        id : '',
        nama : '',
        nik : '',
        instansi : '',
        email : '',
        hp : '',
        alamat : '',
        aksesWilayah : '',
        des_kel : '',
        kecamatan : '',
        keterangan : '',
        username : '',
        password : "",
        confirmPassword: "",
      },
      errorMessage: '',
      signingUp : false,
     
      list_data : [],
      list_kecamatan : [],
      list_desa : [],

      page_first: 1,
      page_last: 0,
      page_limit : 10,
      cari_value: "",
      cek_load_data : false,


      mdl_add: false,
      mdl_edit: false,
      mdl_hapus : false,
      btn_add: false,
      mdl_view : false,


      FETCHING : FETCHING,
      UMUM : UMUM,
      WILAYAH : WILAYAH,
    }
  },
  methods: {


    getView : function(){
      this.cek_load_data = true
      fetch(this.$store.state.url.URL_GENERATE_TOKEN + "view", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
              data_ke: this.page_first,
              cari_value: this.cari_value,
              page_limit : this.page_limit,
          })
      })
          .then(res => res.json())
          .then(res_data => {
            console.log(res_data);
              this.list_data = res_data.data;
              this.page_last = res_data.jmlData;
              this.cek_load_data = false
      });
    },


    addData : function(number) {

      this.setAksesWilayah();
      this.errorMessage = "";
        if (this.validUser()) {
            // Jika user sdh valid lakukan pengiriman data ke server
            const body = {
              username: this.form.username,
              password: this.form.password
            };
            this.signingUp = true;
            fetch(this.$store.state.url.URL_GENERATE_TOKEN+'signup', {
                method: "POST",
                body: JSON.stringify(this.form),
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                }
            }).then((response) => {
                this.signingUp = false;
                if (response.ok) {
                    this.Notify('Sukses Menambah Data', 'primary', 'check_circle_outline');
                    // this.getView();
                    // this.$router.push('/login');
                    // return response.json();
                }
                else{
                  return response.json().then(error => {
                    throw new Error(error.message);
                  });

                }
            })
            .catch((error) => {
              setTimeout(() => {
                this.signingUp = false;
                this.errorMessage = error.message;
              }, 1000);
            });
        }else{
          console.log("tidak valid");

        }



    },


    editData : function(){
      fetch(this.$store.state.url.URL_GENERATE_TOKEN + "editData", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify(this.form)
      }).then(res_data => {
          this.Notify('Sukses Merubah Data', 'warning', 'check_circle_outline');
          this.getView();
      });
    },

    removeData : function(E){
      fetch(this.$store.state.url.URL_GENERATE_TOKEN + "removeData", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({id : this.form.id})
      }).then(res_data => {
          this.Notify('Sukses Menghapus Data', 'negative', 'check_circle_outline');
          this.getView();
      });

    },

    selectData : function(data){
        this.form.id = data.id;
        this.form.nama = data.nama;
        this.form.nik = data.nik;
        this.form.instansi = data.instansi;
        this.form.email = data.email;
        this.form.hp = data.hp;
        this.form.alamat = data.alamat;
        this.form.aksesWilayah = data.aksesWilayah;
        this.form.des_kel = data.des_kel;
        this.form.kecamatan = data.kecamatan;
        this.form.keterangan = data.keterangan;
        this.form.username = data.username;



        this.form.password = data.username;


        this.generateToken()
    },

    generateToken : function(){
      fetch(this.$store.state.url.URL_APP + "auth/crateToken", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify(this.form)
      })
      .then(res => res.json())
      .then(res_data => {
          // this.Notify('Sukses Merubah Data', 'warning', 'check_circle_outline');
          console.log(res_data);

          this.token = res_data.token
          // this.getView();
      });
    },

    validUser : function(){
      if (this.form.password !== this.form.confirmPassword) {
          this.errorMessage = "Password dan Confirm Password harus sama. !";
          return false;
      }
      // Memulai proses validasi melalui skema Joi yang sebelumnya dibuat
      // req.body merupakan data yang di kirim oleh client dan schema merupakan skema joi yg di buat sebelumnya
      const body = {
              username: this.form.username,
              password: this.form.password
      };
      const result = Joi.validate(body, schema);

      if (result.error === null) {
          return true;
      }
      if (result.error.message.includes("username")) {
          // jika pesan error yang dihasilkan mengandung char "username" maka
          this.errorMessage = "Username tidak valid (Min : 6 dan Max : 14 Karakter)";
      } else {
          this.errorMessage = "Password tidak valid (Min : 6 Karakter)";
        //   console.log(result.error);

      }
      return false;
    },
    setAksesWilayah : function(){

      if (this.form.aksesWilayah == 0) {
        console.log("AKSES DESA DI SET")
        this.form.kecamatan = null
      } 
      else if(this.form.aksesWilayah == 1){
        console.log("AKSES KECAMATAN DI SET")
        this.form.des_kel = null
      }
      else if(this.form.aksesWilayah == 2){
        console.log("AKSES KABUPATEN DI SET")
        this.form.kecamatan = null
        this.form.des_kel = null
      }
    },

    getKecamatan : async function() {

      // console.log('========== APUKA ==========');

      this.list_kecamatan = await WILAYAH.getKec('');
      this.form.des_kel = '';
      this.list_desa = await WILAYAH.postDesKel(this.form.kecamatan);

    },

    // ====================================== PAGINATE ====================================
        Notify : function(message, positive, icon){
          this.$q.notify({
            message: message,
            color: positive,
            icon: icon,
            position : 'top',
            timeout: 500,
          })
        },
        btn_prev : function(){
            this.cek_load_data = true;
            if(this.page_first>1){
                this.page_first--
            }else{
                this.page_first = 1;
            }
            this.getView();
        },

        btn_next : function(){
            if(this.page_first >= this.page_last){
                this.page_first == this.page_last
            }else{
                this.page_first++;
            }
            this.getView();
        },

        cari_data : function(){
            this.page_first = 1;
            this.getView();
        },

        indexing : function(index){
            var idx = ((this.page_first-1)*this.page_limit)+index
            return idx
        }


    // ====================================== PAGINATE ====================================







  },

  mounted () {
    this.getKecamatan();
    this.getView();
  },
}
